export default "__VITE_ASSET__29058825__"